export default {
    abs: "abs.",
    activate: "Aktivləşdir",
    add_category: "Kateqoriya əlavə et",
    add_kit: "Kit əlavə edin",
    additional_materials: "Əlavə materiallar",
    archive: "Arxiv",
    are_you_sure_you_want_to_delete_category: "Kateqoriyanı silmək istədiyinizə əminsiniz?",
    are_you_sure_you_want_to_delete_service: "Xidməti silmək istədiyinizə əminsiniz?",
    assistant_reward: "Köməkçinin əmək haqqı",
    average_price: "Orta qiymət",
    categories: "Kateqoriyalar",
    category: "Kateqoriya",
    change_category: "Kateqoriyanı dəyiş",
    change_pricelist: "Qiymət siyahısını dəyiş",
    classificator_code: "Klassifikator kodu",
    classificator_title: "Klassifikator adı",
    complex_service: "Kompleks xidmət",
    complex_services: "Kompleks xidmətlər",
    curator_reward: "Kuratorun əmək haqqı",
    current_value: "Cari dəyər",
    deactivate: "Deaktivləşdir",
    decrease_price: "Qiyməti azaldın",
    discounted_price: "Endirimli qiymət",
    do_not_accrue_bonus: "Bonus hesablanmasın",
    doctor_reward: "Həkim mükafatı",
    fill_from_previous_visits: "Əvvəlki ziyarətlərdən doldurun",
    fixed_materials_expense_sum: "Materialların sabit xərc məbləği",
    import_standard_services: "Standart xidmətləri idxal edin",
    increase_price: "Qiyməti artırın",
    individual_bonus: "Fərdi bonus müalicə alan üçün (%)",
    make_separate: "Ayrı olun",
    manager: "Administrator",
    manager_reward: "Administrator mükafatı",
    mkb_10_diagnosis: "ICD 10-a əsasən diaqnoz",
    money_lost_on_discount: "Endirimlərdə itirilən pul",
    move_to_group: "Qrupa keçin",
    ndfl_code: "Şəxsi gəlir vergisi kodu",
    not_selected: "Müəyyən edilməyib",
    packages_cost: "Komplektlərin maya dəyəri",
    personal_percent_for_assistant: "Assistent üçün fərdi faiz",
    personal_percent_for_curator: "Kurator üçün fərdi faiz",
    personal_percent_for_doctor: "Həkim üçün fərdi faiz",
    personal_percent_for_manager: "Administrator üçün fərdi faiz",
    personal_percent_for_technic: "Texnik üçün fərdi faiz",
    price_can_be_changed: "Müalicə kartında qiymət dəyişə bilər",
    price_from: "Qiymət",
    pricelist_price: "Qiymət siyahısı üzrə qiymət",
    pricelist_short: "Qiymət siyahısı",
    reset_selection: "Seçimi sıfırla",
    send_to_archive: "Arxivə göndər",
    Service: "Xidmət",
    service_category: "Xidmət kateqoriyası",
    service_code: "Xidmət kodu",
    services_not_selected: "Heç bir xidmət seçilməyib",
    technic: "Texnik",
    technic_reward: "Texnik mükafatı",
    teeth_not_selected: "Diş seçilməyib",
    use_visit_anamnez: "Ziyarət tarixçəsindən istifadə edin",
    visit_status: "Statusu ziyarət edin"
}
